export const projects = [
  {
    title: "Lista de tareas diarias",
    subtitle: "HTML, CSS y Javascripts",
    description:
      "Desarrollo de una APP de lista de tareas con responsive web design y con las funcionales de agregar, tachar, completar y eliminar tareas yla implementación de local Storage que sirve para guardar el registro de los datos                                                                                                                                                                                                                                                                                       -",
    image: "./lista.jpg",
    link: "https://lista-de-tares.netlify.app",
  },
  {
    title: "Memorizar",
    subtitle: "HTML, CSS y Javascripts",
    description:
      "Es un pequeño juego donde se pone a pruebas la capacidad de memorizar imagenes.                                                                                                                                                                                                                                                                                                                                                                                                                                     -",
    image: "./memoria.jpg",
    link: "https://memorizar.netlify.app",
  },
  {
    title: "PokemonApp",
    subtitle: "React, Node.js y SQl",
    description:
      "Desarrollo de una SPA Responsive Design (Single Page Application) utilizando React para el Front End y Redux como state management. Todos los componentes fueron realizados con CSS sin el uso de librerías externas. La SPA consume datos de una API externa a través de un Back End desarrollado en Node.js utilizando Express, agregando nuevas funcionalidades a la API original. Funcionalidades del proyecto: Formulario controlado para la creación de un nuevo Pokemon, ordenamientos y filtros, paginación.",
    image: "./pokemonApp.png",
    // link: "https://henryhealthy.shop/pi-pokemon/",
  },
  {
    title: "E-commerce Healthy Shop",
    subtitle: "HTML, Javascripts, React-Redux, Material UI, Nodejs, express, MySQL , Firebase, Cloudinary, Nodemailer, Mercadopago",
    description:
      "Es un Ecommerce de alimentos saludable con versiones WEB y Mobile. Desarrollo este proyecto junto a mis compañeros de equipo para la evaluación final del bootcamp Henry                                                                                                                                                                                                                                                                                                                                             -",
    image: "./HealthyShop.png",
    link:  "https://henryhealthy.shop/catalogo",
  },
];

// export const testimonials = [
//   {
//     quote:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
//     image: "https://randomuser.me/api/portraits/men/1.jpg",
//     name: "Jesse Hicks",
//     company: "Zoozle",
//   },
//   {
//     quote:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
//     image: "https://randomuser.me/api/portraits/men/94.jpg",
//     name: "Ruben Alvarez",
//     company: "Dooble.io",
//   },
// ];

export const skills = [
  "JavaScript",
  "HTML",
  "CSS",
  "React",
  "Redux",
  "Nodejs",
  "SQL",
  "Git",
  "Github",
  "npm",
  "Postgres",
  "Sequelize",
  "Postman",
  "Netlify",
  "Slack",
  "Discord",
  "SCRUM"
];



// WEBPACK FOOTER //
// ./src/data.js